import React from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';
import mypageArrowImg from 'images/mypage_arrow.png';
import {MypageSetInner, Arrowright, Setlistinner, Setlist, SetlistLink, Setlistname, Setlistcont, Setlistdata, Switchinput, Switchlabel} from './style';

export default function PolicyListLayout() {
    return (
        <MypageSetInner>
            <TitleHeader title={"약관 및 정책"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/>

            <Setlistinner>
                <SetList path={`/mypage/terms_and_conditions`} listname={"이용약관"} />
                <SetList path={`/mypage/private_policy`} listname={"개인정보처리방침"} />
                <SetList path={`/mypage/business_info`} listname={"사업자정보"} />
            </Setlistinner>
            
        </MypageSetInner>
    )
}

function SetList ({listname , path}) {
    return (
 
        <Setlist>
            <SetlistLink to={path}>
                <Setlistname>{listname}</Setlistname>
                <Setlistcont>
                    <Arrowright><img src={mypageArrowImg}></img></Arrowright>
                </Setlistcont>
            </SetlistLink>
        </Setlist>

    )
}

function SetListToggle ({listname , path}) {
    return (
 
        <Setlist>
            <SetlistLink to={path}>
                <Setlistname>{listname}</Setlistname>
                <Setlistcont>
                    <Switchinput type="checkbox" id="weekedSW"></Switchinput>
                        <Switchlabel for="weekedSW"></Switchlabel>
                </Setlistcont>
            </SetlistLink>
        </Setlist>

    )
}
